export const useNotify = () => {
  const data = useState(
    'notifyCount',
    (): {
      mention: number
      comment: number
      like: number
      system: number
      message: number
    } => {
      return {
        mention: 0,
        comment: 0,
        like: 0,
        system: 0,
        message: 0
      }
    }
  )

  async function refresh() {
    data.value = await fetchNotifyCount()
  }

  return {
    data,
    refresh
  }
}
